import React from 'react'

const RequestWarrantyStocksInPage = React.lazy(() => import('pages/RequestWarrantyStocksIn/pages/RequestWarrantyStocksInPage'));

const RequestWarrantyStocksInRoutes = [
    {
        path: '/request-warranty-stocks-in',
        exact: true,
        name: 'Nhập trả máy bảo hành',
        function: 'RS_RQ_WARRANTY_REPAIR_ASSIGN',
        component: RequestWarrantyStocksInPage,
    },
]

export default RequestWarrantyStocksInRoutes
